export const normalizeId = (value) => (value || '').toString().replace(/-/g, '').toLowerCase();

export const formatDateTime = (value) => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleString('ru-RU');
};
